import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { GlobalStateProvider, useGlobalState } from "./utils/globalState";
import SuperAdmin from "./components/SuperAdmin/SuperAdmin";
import Login from "./components/Auth/Login";

function App() {
  const { user } = useGlobalState();

  return (
    <Routes>
      <Route path="/login" element={!user ? <Login /> : <Navigate to="/" replace />} />
      <Route path="/superadmin/*" element={user?.role === "super_admin" ? <SuperAdmin /> : <Navigate to="/login" replace />} />
      <Route
        path="/"
        element={
          !user ? <Login /> : user.role === "super_admin" ? <Navigate to="/superadmin" replace /> : <Login />
        }
      />
      <Route path="*" element={!user ? <Login /> : <Navigate to="/" replace />} />
    </Routes>
  );
}

function Root() {
  return (
    <GlobalStateProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </GlobalStateProvider>
  );
}

export default Root;